import React, { useState } from "react";
import {
  Navbar,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faChevronDown,
  faDesktop,
  faMobile,
  faCheck,
  faEarthAmericas,
  faCircleNotch,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { AutoSaveStatus } from "../../useAutoSave";
import withStyles from "isomorphic-style-loader/withStyles";
import classNames from "classnames";
import styles from "./styles.scss";
import PrimaryButton from "../../../../../../../toolkit/primaryButton";

interface TopBarProps {
  pages: Record<string, string>;
  selectedPage: string;
  onPageChange: (page: string) => void;
  isMobileView: boolean;
  autoSaveStatus: AutoSaveStatus;
  saveAndPublish: () => void;
  isSavingAndPublishing: boolean;
  onBackToSetup?: () => void;
  onSwitchView: () => void;
}

const TopBar = ({
  pages,
  selectedPage,
  onPageChange,
  isMobileView,
  autoSaveStatus,
  saveAndPublish,
  isSavingAndPublishing,
  onBackToSetup,
  onSwitchView,
}: TopBarProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

  return (
    <>
      <Navbar className={styles.topbar} expand="md">
      <div className={styles.leftSection}>
        <Button
          color="link"
          className={styles.backButton}
          onClick={onBackToSetup || (() => window.history.back())}
          title="Back to Setup"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>

        <span className={styles.editText}>Currently Editing:</span>

        <Dropdown
          isOpen={dropdownOpen}
          toggle={toggleDropdown}
          className={styles.pageDropdown}
        >
          <DropdownToggle caret={false} className={styles.dropdownToggle}>
            {selectedPage}
            <FontAwesomeIcon
              icon={faChevronDown}
              className={styles.dropdownIcon}
            />
          </DropdownToggle>
          <DropdownMenu>
            {Object.values(pages).map(page => (
              <DropdownItem key={page} onClick={() => onPageChange(page)}>
                {page}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>

      <div className={styles.rightSection}>
        {autoSaveStatus !== "idle" && (
          <div
            className={classNames(styles.autoSaveStatus, {
              [styles.saving]: autoSaveStatus === "saving",
              [styles.saved]: autoSaveStatus === "saved",
              [styles.error]: autoSaveStatus === "error",
            })}
          >
            {autoSaveStatus === "saving" && (
              <>
                <FontAwesomeIcon icon={faCircleNotch} spin />
                <span>Saving...</span>
              </>
            )}
            {autoSaveStatus === "saved" && (
              <>
                <FontAwesomeIcon icon={faCheck} />
                <span>Saved</span>
              </>
            )}
            {autoSaveStatus === "error" && (
              <>
                <FontAwesomeIcon icon={faExclamationCircle} />
                <span>Save failed</span>
              </>
            )}
          </div>
        )}

        <Button
          color="link"
          className={`${styles.iconButtonOutlined} ${
            !isMobileView ? styles.selected : ""
          }`}
          title="Desktop View"
          onClick={onSwitchView}
        >
          <FontAwesomeIcon icon={faDesktop} />
        </Button>
        <Button
          color="link"
          className={`${styles.iconButtonOutlined} ${
            isMobileView ? styles.selected : ""
          }`}
          title="Mobile View"
          onClick={onSwitchView}
        >
          <FontAwesomeIcon icon={faMobile} />
        </Button>

        <PrimaryButton
          variant="primary"
          className={styles.saveAndPublishButton}
          onClick={saveAndPublish}
          loading={isSavingAndPublishing}
          loadingText="Saving..."
        >
          <>
            <FontAwesomeIcon icon={faEarthAmericas} size="sm" className="me-2" />
            Save
          </>
        </PrimaryButton>
      </div>
    </Navbar>
    </>
  );
};

export default withStyles(styles)(TopBar);
